import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import { WireInstructionSection } from '@bingads-webui-cc-react/offline-instruction-display';
import { InlineInfoAlert } from '@bingads-webui-cc-react/alert';

import { PropTypeI18n } from './shapes';

function OfflinePaymentMethodSectionUnwrapped({
  i18n,
  accountNumber,
  currencyCode,
  countryCode,
  fetchOfflinePiInstructions,
}) {
  const [wireInstructions, setWireInstructions] = useState(null);

  useEffect(() => {
    const asyncToken = createAsyncToken(fetchOfflinePiInstructions({ currencyCode, countryCode }))
      .on({
        onSuccess: ([{ wireInstructions: wireInstr = null }]) => {
          setWireInstructions(wireInstr);
        },
      });

    return () => {
      asyncToken.cancel();
    };
  }, [currencyCode, countryCode, fetchOfflinePiInstructions]);

  return (
    <div className="offline-pi-section">
      <InlineInfoAlert>{i18n.getString(_TL_('You must include your Manager account name and your Microsoft Advertising account number ({0}) for us to process your payment.')).replace('{0}', accountNumber)}</InlineInfoAlert>
      {
        wireInstructions &&
        <WireInstructionSection
          i18n={i18n}
          bankName={wireInstructions.BankName}
          wireDetails={wireInstructions.Details}
        />
      }
    </div>
  );
}

OfflinePaymentMethodSectionUnwrapped.propTypes = {
  i18n: PropTypeI18n.isRequired,
  accountNumber: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  fetchOfflinePiInstructions: PropTypes.func.isRequired,
};

OfflinePaymentMethodSectionUnwrapped.defaultProps = {
};

export const OfflinePaymentMethodSection = memo(OfflinePaymentMethodSectionUnwrapped);
